const SECURE_LECTURE_LOGGING_API = '/api/membership/secure/global/lecture'
export const TrackingApi = {
  InitLecture: SECURE_LECTURE_LOGGING_API,
  UpdateLecture: SECURE_LECTURE_LOGGING_API,
  InitQuiz: '/api/membership/quiz',
  UpdateQuiz: '/api/membership/quiz/session',
} as const
